import { ChangeEvent, useState } from "react";
import { Col, Form } from "reactstrap";
import { Btn, H6, P } from "../../../../AbstractElements";
import { BillingInformation, FillFollowingInformation, ProceedToNext } from "../../../../Constant";
import { BillingFormProp } from "../../../../Type/FormLayoutType";
import { BillingUserDetails1 } from "./BillingUserDetails1";
import { BillingUserDetail2 } from "./BillingUserDetail2";
import ShowError from "../../common/ShowError";

const BillingForm = ({ callbackActive }: BillingFormProp) => {
  const [studentValidationForm, setStudentValidationForm] = useState({ firstName: "", lastName: "", contact: "", email: "", address: "", country: "", state: "", zip: "", rememberNextTime: false, otherNotes: "" });
  const { firstName, lastName, contact, email, address, country, state, zip, rememberNextTime, otherNotes } = studentValidationForm;
  const getUserData = (event: ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    const value = name === "rememberNextTime" ? event.target.checked : event.target.value;
    setStudentValidationForm({ ...studentValidationForm, [name]: value });
  };
  const handleNextButton = () => {
    if (firstName !== "" && lastName !== "" && contact !== "" && email !== "" && address !== "" && country !== "" && state !== "" && zip !== "" && rememberNextTime !== false && otherNotes !== "") {
      callbackActive(2);
    } else {
      ShowError();
    }
  };
  
  return (
    <>
      <H6>{BillingInformation}</H6>
      <P className="f-light">{FillFollowingInformation}</P>
      <Form onSubmit={(event) => event.preventDefault} className="row g-3 needs-validation " noValidate>
        <BillingUserDetails1 studentValidationForm={studentValidationForm} getUserData={getUserData} />
        <BillingUserDetail2 studentValidationForm={studentValidationForm} getUserData={getUserData}/>        
        <Col xs="12" className="text-end">
          <Btn onClick={handleNextButton} color="primary">{ProceedToNext}<i className="fa fa-truck proceed-next pe-2" /></Btn>
        </Col>
      </Form>
    </>
  );
};

export default BillingForm;
